import api from './api';

export async function getYearlySummary(year) {
  const params = year ? { year } : {};
  const response = await api.get('/analytics/yearly-summary', { params });
  return response.data;
}

export async function getCategoryBreakdown(year) {
  const params = year ? { year } : {};
  const response = await api.get('/analytics/category-breakdown', { params });
  return response.data;
}

export async function getCategoryDrilldown(year) {
  const params = year ? { year } : {};
  const response = await api.get('/analytics/category-drilldown', { params });
  return response.data;
}

export async function getTopSpending(year, limit = 10) {
  const params = { limit };
  if (year) params.year = year;
  const response = await api.get('/analytics/top-spending', { params });
  return response.data;
}

export async function getTrends(year) {
  const params = year ? { year } : {};
  const response = await api.get('/analytics/trends', { params });
  return response.data;
}

export async function getOutliers(year) {
  const params = year ? { year } : {};
  const response = await api.get('/analytics/outliers', { params });
  return response.data;
}

export async function getAvailableYears() {
  const response = await api.get('/analytics/years');
  return response.data;
}
